import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from "@angular/core";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-st-loader-svg",
  imports: [],
  templateUrl: "./st-loader-svg.component.html",
  styleUrl: "./st-loader-svg.component.scss",
  encapsulation: ViewEncapsulation.None,
})
export class StLoaderSvgComponent {
  readonly width = input<number>(48);
  readonly height = input<number>(48);
  readonly bg = input<string>("var(--neutral-500)");
  readonly dark = input<string>("var(--neutral-900)");
  readonly accent = input<string>("var(--neutral-700)");
  readonly icon = input<string>("var(--neutral-500)");
}
